import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'filePreview',
  standalone: true,
})
export class FilePreviewPipe implements PipeTransform {
  transform(file: File | string | null): string {
    if (!file) {
      return '/images/default-placeholder.png';
    }

    if (typeof file === 'string') {
      return file.trim(); //handle full URLs, base64, or relative paths
    }

    // Handle File object (uploaded from input)
    return URL.createObjectURL(file);
  }
}
